export default __webpack_public_path__ + "static/flag-slice-09e2e053ca3fd47167be2ead488d0c06.png";